import { render } from "./AlignedOkr.vue?vue&type=template&id=011a0f59&scoped=true"
import script from "./AlignedOkr.vue?vue&type=script&lang=js"
export * from "./AlignedOkr.vue?vue&type=script&lang=js"

import "./AlignedOkr.vue?vue&type=style&index=0&id=011a0f59&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011a0f59"]])

export default __exports__